import { Skeleton } from "@facade/components/ui";

export const OrganizationInfoSkeleton = () => {
  return (
    <>
      <Skeleton className="size-12 rounded-full" />

      <div className="grid flex-1 gap-2">
        <Skeleton className="h-4 w-56" />
        <Skeleton className="h-3 w-40" />
      </div>
    </>
  );
};
